import moment from 'moment';

export function normalizeMobile(mobile) {
  if (mobile == null || mobile === '') {
    return '';
  }
  return String(mobile).trim();
}

export function notificationIncludesMobile(list, mobile) {
  const normalized = normalizeMobile(mobile);
  if (!normalized) {
    return false;
  }
  return (list || []).some(item => normalizeMobile(item) === normalized);
}

export function filterNotificationsForUser(notifications, mobile) {
  const items = Array.isArray(notifications) ? notifications : [];
  const visible = items.filter(item => !notificationIncludesMobile(item.deleteBy, mobile));
  const unreadCount = items.filter(
    item => !notificationIncludesMobile(item.readBy, mobile) && !notificationIncludesMobile(item.deleteBy, mobile)
  ).length;

  return { visible, unreadCount };
}

export function formatNotificationTimeGroup(dateValue) {
  if (!dateValue) {
    return 'Other';
  }

  const parsed = moment(dateValue);
  if (!parsed.isValid()) {
    return 'Other';
  }

  return parsed
    .fromNow()
    .replace(/\b\w/g, char => char.toUpperCase());
}

export function getNotificationTimestamp(item) {
  const value =
    item?.createdAt ||
    item?.created_at ||
    item?.raw?.createdAt ||
    item?.raw?.created_at ||
    item?.raw?.updatedAt ||
    item?.raw?.updated_at;
  const parsed = moment(value);
  return parsed.isValid() ? parsed.valueOf() : 0;
}

export function sortNotificationsByNewest(notifications) {
  return [...(notifications || [])].sort(
    (a, b) => getNotificationTimestamp(b) - getNotificationTimestamp(a)
  );
}

export function groupNotifications(notifications) {
  const order = [];
  const groups = {};

  sortNotificationsByNewest(notifications).forEach(item => {
    const label = item.timeGroup || 'Other';
    if (!groups[label]) {
      groups[label] = [];
      order.push(label);
    }
    groups[label].push(item);
  });

  return order.map(label => ({
    label,
    items: groups[label]
  }));
}

export function getUnreadNotificationCount(notifications) {
  return (notifications || []).filter(item => !item.isRead).length;
}
